import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DadataConfig, DadataParty, DadataSuggestion, DadataType} from '@kolkov/ngx-dadata';
import {PhoneInputComponent} from '../../module/phone-input/phone-input.component';
import {ICuratorRegistration} from '../../models/domain';
import {AccountService} from '../../services/account.service';
import {TranslateService} from '@ngx-translate/core';
import {Event, Router} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CaptchaComponent } from '../../components/captcha/captcha.component';


const API_KEY = '0a1134bc0f54c3eb44b6145b303846c14453a1f8';
@Component({
  selector: 'app-curator-registration',
  templateUrl: './curator-registration.component.html',
  styleUrls: ['./curator-registration.component.scss']
})
export class CuratorRegistrationComponent implements OnInit {
    config: DadataConfig = {
        apiKey: API_KEY,
        type: DadataType.party
    };

    validName: boolean = false;
    validInn: boolean = false;
    validFIO: boolean = false;
    validEmail: boolean = false;
    validPhone: boolean = false;
    validUserAgreement: boolean = false;
    validPersonalData: boolean = false;

    blockExist: boolean = false;
    invalidCaptcha: boolean = false;

    curatorForm: FormGroup;
    dadataParty: DadataParty;

    regInfo: ICuratorRegistration;

    lockSubmitButton: boolean = false;
    public captchaCode: string;
    private _catchaValidationError: string;

    @ViewChild(PhoneInputComponent, { static: true }) phoneInputComponent: PhoneInputComponent;
    @ViewChild('captchaComponent') captchaComponent: CaptchaComponent;


  constructor(private accountService: AccountService,
              private _translateService: TranslateService,
              private router: Router,
              private title: Title){ }

  ngOnInit(): void {
      this.curatorForm = new FormGroup({
          BlockName: new FormControl('', Validators.required),
          Inn: new FormControl('', Validators.required),
          holding: new FormControl(''),
          firstName: new FormControl('', Validators.required),
          lastName: new FormControl('', Validators.required),
          middleName: new FormControl('', Validators.required),
          email: new FormControl('', [Validators.required, Validators.email]),
          userAgreement: new FormControl(false, Validators.requiredTrue),
          personalData: new FormControl(false, Validators.requiredTrue),
          isRacOrg: new FormControl(false),
          }
      )
      this.title.setTitle('Регистрация куратора предприятия')
      this._initTranslations();
  }

    private _initTranslations() {
        this._translateService.get(
            [
                'Common.CaptchaValidationError'
            ])
            .subscribe(
                result => {
                    this._catchaValidationError = result['Common.CaptchaValidationError'];
                });
    }

  updateinn(event: DadataSuggestion){
      this.dadataParty = event.data as DadataParty
      this.curatorForm.get('Inn').patchValue(this.dadataParty.inn)
  }

    changeBlock(event: Event){
      if(this.curatorForm.get('Inn').value != ''){
          this.curatorForm.get('Inn').patchValue('')
      }
  }

  submitRegistration(){
      this.lockSubmitButton = true;

      if(this.curatorForm.get('BlockName').errors && this.curatorForm.get('BlockName').hasError('required')){
          this.validName = true;
          this.curatorForm.get('Inn').patchValue('')
          this.validInn = true;
      } else {this.validName = false; this.validInn = false}
      if( this.curatorForm.get('firstName').errors &&
          this.curatorForm.get('firstName').hasError('required') ||
          this.curatorForm.get('lastName').errors &&
          this.curatorForm.get('lastName').hasError('required') ||
          this.curatorForm.get('middleName').errors &&
          this.curatorForm.get('middleName').hasError('required')){
              this.validFIO = true;
          } else {this.validFIO = false}
      if (!(this.phoneInputComponent.phoneValueWithRegion.length > 10)){
          this.validPhone = true;

      } else {this.validPhone = false}
      if(this.curatorForm.get('email').errors &&
          this.curatorForm.get('email').hasError('required') ||
          this.curatorForm.get('email').hasError('email')){
          this.validEmail = true;
      } else {this.validEmail = false}
      if (this.curatorForm.get('userAgreement').errors || this.curatorForm.get('userAgreement').hasError('requiredTrue')){
          this.validUserAgreement = true
      } else { this.validUserAgreement = false}
      if (this.curatorForm.get('personalData').errors || this.curatorForm.get('personalData').hasError('requiredTrue')){
          this.validPersonalData = true
      } else {this.validPersonalData = false}
      if(!this.validName &&
      !this.validInn &&
      !this.validFIO &&
      !this.validPhone &&
      !this.validEmail &&
      !this.validUserAgreement &&
      !this.validPersonalData &&
      this.curatorForm.valid){
          this.regInfo = this.curatorForm.value
          this.regInfo.phone = this.phoneInputComponent.phoneValueWithRegion
          this.regInfo.captchaCode = this.captchaCode
          console.log(this.regInfo);
          this.accountService.curatorRegistration(this.regInfo).subscribe(res =>{
              if(res.success){
                  alert('Регистрация прошла успешно')
                  window.location.href = './api/v1/Account/redirect-out'
              }
              else if(res.error == 'UserBlockExists'){
                  alert('Такая организация уже зарегистрирована')
                  this.blockExist = true;
                  this.lockSubmitButton = false;
                  this.invalidCaptcha = false;
                  this.captchaComponent.refreshCaptcha();
              }
              else if(res.error == "InvalidCaptcha"){
                  this.invalidCaptcha = true;
                  this.captchaComponent.refreshCaptcha();
                  this.lockSubmitButton = false;
              }
              else if(res.error == "EmailExist"){
                  alert('Такой Email уже используется!')
                  this.lockSubmitButton = false;
                  this.captchaComponent.refreshCaptcha();
              }
              else if(res.error == "LoginExist"){
                  alert('Такой номер телефона уже используется!')
                  this.lockSubmitButton = false;
                  this.captchaComponent.refreshCaptcha();
              }
              else {
                  console.error(res.error)
                  alert('Произошла непредвиденная ошибка. Попробуйте снова.')
                  this.invalidCaptcha = false;
                  this.lockSubmitButton = false;
                  this.captchaComponent.refreshCaptcha();
              }
          })
      } else {this.lockSubmitButton = false; return}
  }
}
